module.exports = __webpack_public_path__ + "fonts/94d168f.ttf";